var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 121,
    viewBox: "0 0 62 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2365 30.8057V120.13H54.6029V50.189C51.6504 55.0971 41.719 61.3473 30.5607 61.3473C13.8807 61.3473 0 47.4857 0 30.8057C0 14.1257 13.8615 0.129883 30.5607 0.129883C47.2598 0.129883 60.7381 13.6272 61.1024 28.8501L61.2174 30.8057H61.2365ZM54.8522 28.8501C54.3537 16.829 43.9238 6.51429 30.5607 6.51429C17.1975 6.51429 6.38432 17.1933 6.38432 30.8057C6.38432 44.4181 17.0633 54.9821 30.5607 54.9821C43.1953 54.9821 53.2609 45.7794 54.6029 33.509L54.8522 28.8501Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber9);
export default __webpack_public_path__ + "static/media/NUMBER_9.0349d01c85b10623fc01d414d03cd93a.svg";
export { ForwardRef as ReactComponent };